import { Box, Container } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { useSettingsContext } from 'src/legacy/components/settings';
import { useSelector } from 'src/legacy/redux/store';

import { BasicInfoCard } from './BasicInfoCard';
import { Breadcrumbs } from './Breadcrumbs';
import { Tabs } from './Tabs';
import { UserDetailsNavigatorContextProvider } from './UserDetailsNavigatorContext';

export const UserDetailsNavigator = () => {
  const { themeStretch } = useSettingsContext();

  const { selectedUser } = useSelector((state) => state.user);

  const displayName = `${selectedUser?.first_name || ''} ${
    selectedUser?.last_name || ''
  }`;

  return (
    <UserDetailsNavigatorContextProvider>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <Breadcrumbs displayName={displayName} />

        <BasicInfoCard displayName={displayName} />

        <Tabs />

        <Box>
          <Outlet />
        </Box>
      </Container>
    </UserDetailsNavigatorContextProvider>
  );
};
